import React, { useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { createStructuredSelector } from 'reselect';
import queryString from 'query-string';
import { cloneDeep, isEqual, isEmpty, get } from 'lodash';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss';
import moment from 'moment';
import {
  getFiltersInfoData,
  getFiltersInfoSuccess,
  updateFiltersData,
  updateSelectedFiltersData,
  updateQueryFilterData,
  getFilterdInfoData,
  clearFilterData,
  mobileFiltersUpdate,
  clearFilteredData,
  updateMultipleFiltersData,
  clearAllClicked,
} from './redux/actions';
import {
  filtersData,
  selectedFiltersData,
  clearAllClickedData,
} from './redux/selectors';
import CheckBoxMUI from '../../../components/atoms/Forms/CheckBox';
import useStyles from './style';
import { Hidden, SwipeableDrawer, useMediaQuery } from '@material-ui/core';
import ButtonMUI from '../../../components/atoms/Button';
import DctSvgIcon from '../../../components/atoms/Svg';
import { canUseDOM } from '../../../utils/canUseDOM';
import SelectMUI from '../../../components/atoms/Forms/Select';
import RadioMUI from '../../../components/atoms/Forms/Radio';
import Calender from '../../../components/atoms/Forms/Calendar';
import Grid from '../../../components/molecules/Grid';
import { analyticsData } from '../../../../../src/constants/Analytics/analytics-data';
import {
  pushAnaylyticsData,
  createDynamicLabels,
} from '../../../../../src/utils/analytics';
import Typography from '../../../components/atoms/Typography';
import CustomLink from '../../../components/atoms/Link';
import {
  checkboxType,
  dictionaryKeys,
  dropdownType,
  calendarType,
  dateRangeKeys,
  priceTaxonomyKey,
  regionTaxonomyKey,
  tripadvisorratingTaxonomyKey,
} from './constants';
import {
  isFilterObjectEmpty,
  extractFiltersFromFiltersData,
  getFilterCount,
  getHelperKeysFromDictionary,
  removeEmpty,
  updateFilterData,
} from '../../../../utils/utility';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import clsx from 'clsx';
import { FILTER_LIST_MOBILE_SECTION, FILTER_CONTAINER } from './locators';
import { searchTermData } from '../GlobalSearchSubLayout/redux/selectors';
import {
  getComponentName,
  getPageName,
} from '../../../utils/getPageComponentInfo';
import {
  EVENT_TYPE,
  ATTRIBUTE_TYPE,
  TAG_TEXT,
} from '../../../../constants/index';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { getLocalStorage } from './../../../../utils/localStorage';

import FavoriteContext from './../../../../context/favorite/FavoriteContext';

/*
 *  This mapes atoms to filter fields
 */
const mapper = {
  checkbox: CheckBoxMUI,
  dropdown: SelectMUI,
  radio: RadioMUI,
  calendar: Calender,
};

/*
 *  This function returns payload for solr API call for different cases on different pages
 */
const getSolrPayloadForFilters = (
  filters,
  shouldFetchFilterDetails,
  contentType,
  isGlobalSearchTemplate,
  searchTerm,
  language,
  category,
  filtersData,
  isEditor,
  attributeListingTag,
  props
) => {
  const { parentComponentName } = props;

  try {
    let solrPayloadToFetchFilter = {};

    let shouldCallAPI = true;

    // In case of global search page search term is sent to API
    if (contentType == '' && parentComponentName === 'FavoriteSubLayout') {
      contentType = 'favorites';
    }
    if (!isGlobalSearchTemplate) {
      solrPayloadToFetchFilter.contentType = contentType;
    } else {
      solrPayloadToFetchFilter.searchTerm = searchTerm;
    }
    let favData = JSON.parse(getLocalStorage('favorites') || '[]');

    solrPayloadToFetchFilter.language = language;
    solrPayloadToFetchFilter.facetFields = [];
    if (parentComponentName === 'FavoriteSubLayout') {
      solrPayloadToFetchFilter.itemIDs = favData;
    }
    //For attribute listing page initial card limits are driven by sitecore,
    solrPayloadToFetchFilter.limit =
      contentType === ATTRIBUTE_TYPE
        ? Number(getDictionaryText('attributePageLoadCount'))
        : 9;
    solrPayloadToFetchFilter.offset = 0;
    solrPayloadToFetchFilter.filters = [];
    solrPayloadToFetchFilter.isPreviewMode = isEditor;
    if (category) {
      solrPayloadToFetchFilter.filters.push({
        key: get(category, 'taxonomyKey.value', ''),
        value: get(category, 'searchKey.value', ''),
      });
    }

    if (shouldFetchFilterDetails) {
      filters &&
        filters.forEach(filter => {
          if (get(filter, 'fields.taxonomyKey')) {
            solrPayloadToFetchFilter.facetFields.push(
              filter.fields.taxonomyKey.value
            );
          }
        });
      const searchString = queryString.parse(
        window && window.location && window.location.search,
        { arrayFormat: 'comma' }
      );
      contentType === ATTRIBUTE_TYPE &&
        solrPayloadToFetchFilter.filters.push({
          key: TAG_TEXT,
          value: (searchString && searchString.tag) || '',
        });
    } else {
      if (!isEmpty(filters)) {
        if (!isGlobalSearchTemplate) {
          solrPayloadToFetchFilter.sortingOrder = {
            order: 'asc',
            sortBy: 'name',
          };
        }
        if (filters.startDate) {
          if (filters.endDate) {
            solrPayloadToFetchFilter.dateRange = {
              startDateField: dateRangeKeys.startDateAPIKey,
              startDate: filters.startDate,
              endDateField: dateRangeKeys.endDateAPIKey,
              endDate: filters.endDate,
            };
          } else {
            shouldCallAPI = false;
          }
        }
        Object.keys(filters).forEach(key => {
          if (
            !(key === dateRangeKeys.startDate || key === dateRangeKeys.endDate)
          ) {
            if (Array.isArray(filters[key]) && filters[key].length > 0) {
              filters[key].forEach(filter => {
                let data = {
                  key: key,
                  value: '',
                };
                data.value = filter;
                solrPayloadToFetchFilter.filters.push(data);
              });
            } else if (!Array.isArray(filters[key]) && filters[key]) {
              if (key === regionTaxonomyKey) {
                let data = {
                  key: key,
                  value: filters[key],
                };
                solrPayloadToFetchFilter.filters.push(data);
              } else {
                let data = {
                  key: key,
                  value: filters[key],
                };
                solrPayloadToFetchFilter.filters.push(data);
              }
            }
          }
        });
      }
      contentType === ATTRIBUTE_TYPE &&
        solrPayloadToFetchFilter.filters.push({
          key: TAG_TEXT,
          value: attributeListingTag,
        });
    }
    if (shouldCallAPI) {
      return solrPayloadToFetchFilter;
    } else {
      return false;
    }
  } catch (err) {
    console.error('Error while setting payload data', err);
  }
};

/*
 *  This function returns equality of two states based on the values selected in them by user
 */
const isStateEqual = (dummy, original) => {
  let isEqual = true;
  if (dummy.length === original.length) {
    for (let key in dummy) {
      if (JSON.stringify(dummy[key]) !== JSON.stringify(original[key])) {
        isEqual = false;
      }
    }
  } else {
    isEqual = false;
  }

  return isEqual;
};

const Filters = props => {
  const classes = useStyles();
  const [attributeListingTag, setAttributeListing] = React.useState('');
  const [shouldOpenDrawer, setShouldOpenDrawer] = React.useState(false);
  const [shouldCheckURL, setShouldCheckURL] = React.useState(true);
  const [shouldUpdateDummyState, setShouldUpdateDummyState] = React.useState(
    true
  );
  const [dummyFiltersData, setDummyFiltersData] = React.useState([]);
  const [dummyFiltersLength, setDummyFiltersLength] = React.useState(0);
  const [isFirstLoad, setIsFirstLoad] = React.useState(true);
  const [stateSearchTerm, setStateSearchTerm] = React.useState('');
  const isMobile = useMediaQuery('(max-width:1023px)');
  const pageName = getPageName(props);
  const componentName = getComponentName(props);
  const { appConfig: apiUrl, parentComponentName } = props;
  const { favorites } = useContext(FavoriteContext);

  let isEditor;

  const previewMode =
    props &&
    props.sitecoreContext &&
    props.sitecoreContext.pageState &&
    props.sitecoreContext.pageState.toLowerCase();

  if (isExperienceEditorActive() || previewMode === 'preview') {
    isEditor = true;
  } else {
    isEditor = false;
  }

  // Fetch inital filters data from solr API
  useEffect(() => {
    if ((!isGlobalSearchTemplate && language && contentType) || (!isGlobalSearchTemplate && language && parentComponentName === 'FavoriteSubLayout')) {

      if (isSolrResponseForFiltersAvailable) {
        const filtersData = updateFilterData(solRresponse, filters, dictionary);
        if (filtersData) {
          props.getFiltersInfoSuccess({ results: filtersData, apiResult: solRresponse });
        }
      } else {
        const payload = getSolrPayloadForFilters(
          filters,
          true,
          contentType,
          isGlobalSearchTemplate,
          searchTerm,
          language,
          category,
          [],
          isEditor,
          attributeListingTag,
          props
        );
        var SolrFilterAPIURL = apiUrl.SOLR_FILTERS_DATA;
        if (parentComponentName === 'FavoriteSubLayout') {
          SolrFilterAPIURL = apiUrl.SOLR_FAVORITE_SEARCH_API
        }
        if (payload) {
          props.getFiltersInfoData({
            url: `${isGlobalSearchTemplate
              ? apiUrl.SOLR_SEARCH_API
              : SolrFilterAPIURL
              }`,
            payload: payload,
            sitecoreFilters: filters,
            dictionary: props.t,
          });
        }
      }
    }
  }, [get(props, 'sitecoreContext.language', '')]);

  const { filters, priceRangeHelpText, title, results: solRresponse } = props.fields;
  const { searchTermData, clearAllClickedData } = props;
  const dictionary = props && props.t;
  const language = get(props, 'sitecoreContext.language', '');
  const isSolrResponseForFiltersAvailable = solRresponse && solRresponse.facetResult && Object.keys(solRresponse.facetResult).length > 0;
  const contentType = get(
    props,
    'sitecoreContext.route.fields.contentType.fields.taxonomyKey.value',
    ''
  ).toLowerCase();

  const category = get(
    props,
    'sitecoreContext.route.fields.category.fields',
    ''
  );
  const templateName = get(props, 'sitecoreContext.route.templateName', '');
  // this key is used to handle global search cases
  const isGlobalSearchTemplate = templateName === 'GlobalSearchResult';

  // Reading keys from dictionary
  const helperKeys = getHelperKeysFromDictionary(dictionary, dictionaryKeys);
  const {
    clearAllText,
    seeLessText,
    seeMoreText,
    applyText,
    resetText,
    selectedFilterText,
    filtersText,
  } = helperKeys;

  // this section calls filter API when user changes the search term on global search results page
  if (searchTermData && stateSearchTerm !== searchTermData.data) {
    const searchTerm = searchTermData.data;
    const payload = getSolrPayloadForFilters(
      filters,
      true,
      contentType,
      isGlobalSearchTemplate,
      searchTerm,
      language,
      category,
      [],
      isEditor,
      attributeListingTag,
      props
    );
    var SolrFilterAPIURL = apiUrl.SOLR_FILTERS_DATA;
    if (parentComponentName === 'FavoriteSubLayout') {
      SolrFilterAPIURL = apiUrl.SOLR_FAVORITE_SEARCH_API
    }

    if (payload) {
      props.getFiltersInfoData({
        url: `${isGlobalSearchTemplate
          ? apiUrl.SOLR_SEARCH_API
          : SolrFilterAPIURL
          }`,
        payload: payload,
        sitecoreFilters: filters,
        dictionary: props.t,
      });
    }
    setStateSearchTerm(searchTermData.data);
  }
  const addAnalyticsInfo = (target, isMobile = false) => {
    let analyticsCapturedData;
    if (isMobile) {
      analyticsCapturedData = {
        ...analyticsData.pageBodyInteraction.filterMobileBtnClick,
      };
    } else {
      analyticsCapturedData = {
        ...analyticsData.pageBodyInteraction.filterBtnClick,
      };
    }
    if (target.name !== dateRangeKeys.startDate && target.value) {
      const obj = {
        ...analyticsCapturedData,
        ...{ label: target.value },
      };
      if (target.checked !== undefined) {
        obj.label = `${target.checked
          ? analyticsData.dataLinksText.checkedText
          : analyticsData.dataLinksText.uncheckedText
          } - ${obj.label}`;
      } else if (target.name === dateRangeKeys.endDate) {
        let startDate = '';
        filtersData.forEach(item => {
          if (item.type === calendarType) {
            startDate = item.startDate;
          }
        });
        obj.label = `Start_Date - ${moment(startDate.value).format(
          'DD/MM/YYYY'
        )} && End_Date - ${moment(target.value).format('DD/MM/YYYY')}`;
      }
      obj.label = createDynamicLabels([pageName, componentName, obj.label]);
      pushAnaylyticsData(obj);
    }
  };
  // Extracting search term from URL which is used in case user is on global search page
  let searchTerm = '';
  if (canUseDOM) {
    const searchString = queryString.parse(
      window && window.location && window.location.search,
      { arrayFormat: 'comma' }
    );
    if (
      Object.keys(searchString).length !== 0 &&
      searchString &&
      searchString.searchTerm
    ) {
      searchTerm = searchString.searchTerm;
    }
  }
  // removing animation class from parent node in case of mobile
  if (isMobile && canUseDOM) {
    const filterSection = document.querySelector(
      `[data-locator='${FILTER_CONTAINER}']`
    );
    if (
      filterSection &&
      filterSection.parentNode &&
      filterSection.parentNode.classList.contains('sectionSlideUp')
    ) {
      filterSection.parentNode.classList.remove('sectionSlideUp');
    }
  }

  let filtersDataFromSitecore = '';
  if (isSolrResponseForFiltersAvailable) {
    filtersDataFromSitecore = updateFilterData(solRresponse, filters, dictionary);
  }
  const propsFiltersData = get(props, 'filtersData.data', '');
  const filtersTotalResult = get(props, 'filtersData.totalResults', '');
  const filtersData = (propsFiltersData.length > 0 && propsFiltersData) || filtersDataFromSitecore || [];

  let filtersDataLength = filtersTotalResult || solRresponse && solRresponse.totalResults;
  if (parentComponentName === 'FavoriteSubLayout') {
    filtersDataLength = favorites.length;
  }

  // Returning from component if filterData state is empty
  if (filtersData && filtersData.length === 0) {
    return '';
  }

  // Creating and updating dummy state for filters on mobile
  if (
    dummyFiltersData.length === 0 ||
    (filtersData &&
      filtersData.length > 0 &&
      !isStateEqual(dummyFiltersData, filtersData) &&
      isEqual(
        props.selectedFiltersData.data,
        extractFiltersFromFiltersData(filtersData)
      ) &&
      shouldUpdateDummyState)
  ) {
    let data = cloneDeep(filtersData);
    setDummyFiltersData(data);
    setDummyFiltersLength(props.selectedFiltersData.filterCount);
  }

  const payloadForAttributeListingAPICall = () => {
    let tagValue;
    let solrPayloadToFetchFilter = {};
    if (canUseDOM) {
      const params = new URLSearchParams(window.location.search);
      tagValue = params && params.get(TAG_TEXT);
    }
    solrPayloadToFetchFilter.contentType = contentType;
    solrPayloadToFetchFilter.language = language;
    solrPayloadToFetchFilter.facetFields = [];
    //For attribute listing page initial card limits are driven by sitecore,
    solrPayloadToFetchFilter.limit = Number(
      getDictionaryText('attributePageLoadCount')
    );
    solrPayloadToFetchFilter.offset = 0;
    solrPayloadToFetchFilter.filters = [{ key: TAG_TEXT, value: tagValue }];
    solrPayloadToFetchFilter.isPreviewMode = isEditor;

    return solrPayloadToFetchFilter;
  };

  /*
   *  This function gets called when user is on global search result page and needs to fetch intial
   *  search response when user either clicks on clearAll button or removes all filters
   */
  const fetchSearchResults = (searchTerm, language) => {
    let solrPayloadToFetchFilter = {
      searchTerm: searchTerm,
      language: language,
      facetFields: [],
      limit: 9,
      offset: 0,
      filters: [],
      isPreviewMode: isEditor,
    };
    var SolrFilterAPIURL = apiUrl.SOLR_FILTERS_DATA;
    if (parentComponentName === 'FavoriteSubLayout') {
      SolrFilterAPIURL = apiUrl.SOLR_FAVORITE_SEARCH_API
    }
    props.getFilterdInfoData({
      apiUrl: `${isGlobalSearchTemplate
        ? apiUrl.SOLR_SEARCH_API
        : SolrFilterAPIURL
        }`,
      payload: solrPayloadToFetchFilter,
    });
  };

  /*
   *  This function gets called when user clicks on View All listing on filter seaction
   *  this returns all responses for that listing page
   */
  const fetchAllResults = (contentType, language) => {

    let favData = [];
    var SolrFilterAPIURL = apiUrl.SOLR_FILTERS_DATA;

    if (parentComponentName === 'FavoriteSubLayout') {
      favData = JSON.parse(getLocalStorage('favorites') || '[]');
      SolrFilterAPIURL = apiUrl.SOLR_FAVORITE_SEARCH_API
      contentType = 'favorites';
    }
    let solrPayloadToFetchFilter = {
      contentType: contentType,
      language: language,
      facetFields: [],
      itemIDs: favData,
      limit: 9,
      offset: 0,
      filters: [],
      isPreviewMode: isEditor,
      sortingOrder: {
        order: 'asc',
        sortBy: 'name',
      },
    };

    if (category) {
      solrPayloadToFetchFilter.filters.push({
        key: get(category, 'taxonomyKey.value', ''),
        value: get(category, 'searchKey.value', ''),
      });
    }
    props.clearFilterData();


    props.getFilterdInfoData({
      apiUrl: `${SolrFilterAPIURL}`,
      payload: solrPayloadToFetchFilter,
    });
  };

  const payloadForSearchCall = (language) => {
    let favData = JSON.parse(getLocalStorage('favorites') || '[]');

    let solrPayloadToFetchFilter = {};
    solrPayloadToFetchFilter.itemIDs = favData;
    solrPayloadToFetchFilter.language = language;
    solrPayloadToFetchFilter.facetFields = [];
    solrPayloadToFetchFilter.limit = 9;
    solrPayloadToFetchFilter.offset = 0;
    solrPayloadToFetchFilter.filters = [];

    return solrPayloadToFetchFilter;
  };

  const fetchFavoriteListing = () => {
    const { appConfig = {} } = props;

    const payload = payloadForSearchCall(language);
    props.getFilterdInfoData({
      apiUrl: `${appConfig.SOLR_FAVORITE_SEARCH_API}`,
      payload: payload,
    });
  };

  const fetchAttributeListingDataOnClearAllFilters = () => {
    let solrPayloadToFetchFilter = payloadForAttributeListingAPICall();

    props.getFilterdInfoData({
      apiUrl: apiUrl.SOLR_FILTERS_DATA,
      payload: solrPayloadToFetchFilter,
    });
  };

  /*
   *  This function gets called when user chagnes filters on mobile
   */
  const onChangeMobile = event => {
    const target = {
      name: event.target.name,
      value: event.target.value,
      checked: event.target.checked,
    };
    addAnalyticsInfo(target, true);
    setIsFirstLoad(false);
    let data = cloneDeep(dummyFiltersData);
    let filtersLength = dummyFiltersLength;
    data.map(value => {
      if (value.fieldName.value === target.name) {
        if (value.type === checkboxType) {
          value.listItems.map(list => {
            if (list.fields.key.value === target.value) {
              list.fields.selected.value = target.checked;
            }

            return list;
          });
        } else {
          value.selectedValue.value = target.value;
        }
      } else if (value.type === calendarType) {
        if (target.name === dateRangeKeys.startDate) {
          value.startDate.value = target.value;
        } else if (target.name === dateRangeKeys.endDate) {
          value.endDate.value = target.value;
        }
      }

      return value;
    });

    filtersLength = getFilterCount(extractFiltersFromFiltersData(data));
    setDummyFiltersData(data);
    setShouldUpdateDummyState(false);
    setDummyFiltersLength(filtersLength);
  };

  /*
   *  This function checks selected filters with store state and existing component state
   *  and if they are not equal then call API to fetch latest results based on filters selected
   */
  const updateSelectedFilters = filtersData => {
    const selectedFilters = extractFiltersFromFiltersData(filtersData);
    const isEmptyObject = isFilterObjectEmpty(selectedFilters);
    if (!isEmptyObject) {
      let urlQueryParams = cloneDeep(selectedFilters);
      urlQueryParams = removeEmpty(urlQueryParams);
      if (isGlobalSearchTemplate) {
        urlQueryParams.searchTerm = searchTerm;
      }
      const query = queryString.stringify(urlQueryParams, {
        arrayFormat: 'comma',
      });
      if (canUseDOM) {
        window.history.replaceState(
          { turbolinks: {} },
          '',
          `?${query}${contentType === ATTRIBUTE_TYPE
            ? `&${TAG_TEXT}=${attributeListingTag}`
            : ''
          }`
        );
      }
    } else {
      if (isGlobalSearchTemplate) {
        const query = queryString.stringify(
          { searchTerm: searchTerm },
          {
            arrayFormat: 'comma',
          }
        );
        if (canUseDOM) {
          window.history.replaceState({ turbolinks: {} }, '', `?${query}`);
        }
      } else {
        window.history.replaceState(
          { turbolinks: {} },
          '',
          contentType === ATTRIBUTE_TYPE
            ? `?${TAG_TEXT}=${attributeListingTag}`
            : window.location.pathname
        );
      }
    }

    if (canUseDOM) {
      const metaOGUrl = document.querySelector('meta[name="og:url"]');
      // setting current url with filters in OG url meta tag
      // so every time filter gets changes we have updated sharable URL
      if (metaOGUrl) {
        metaOGUrl.content = window.location.href
      }
    }

    if (!isEqual(props.selectedFiltersData.data, selectedFilters)) {
      props.updateSelectedFiltersData(selectedFilters);
      if (!isEmptyObject) {
        // Fetching Filtered Results
        const payload = getSolrPayloadForFilters(
          selectedFilters,
          false,
          contentType,
          isGlobalSearchTemplate,
          searchTerm,
          language,
          category,
          filtersData,
          isEditor,
          attributeListingTag,
          props
        );
        var SolrFilterAPIURL = apiUrl.SOLR_FILTERS_DATA;

        if (parentComponentName === 'FavoriteSubLayout') {
          SolrFilterAPIURL = apiUrl.SOLR_FAVORITE_SEARCH_API
        }
        if (payload) {
          props.getFilterdInfoData({
            apiUrl: `${isGlobalSearchTemplate
              ? apiUrl.SOLR_SEARCH_API
              : SolrFilterAPIURL
              }`,
            payload: payload,
          });
        }
      } else {
        // this will fetch intial search results in case user clears all applied filters
        if (isGlobalSearchTemplate) {
          if (!isFirstLoad) {
            fetchSearchResults(searchTerm, language);
          } else if (clearAllClickedData && clearAllClickedData.data) {
            setTimeout(() => {
              fetchSearchResults(searchTerm, language);
            }, 10);
            if (clearAllClickedData && clearAllClickedData.data) {
              props.clearAllClicked(false);
            }
          }
        } else if (contentType === ATTRIBUTE_TYPE) {
          fetchAttributeListingDataOnClearAllFilters();
        } else {
          props.clearFilteredData();
        }
      }
    }
  };

  if (!shouldCheckURL) {
    updateSelectedFilters(filtersData);
  }
  // Reading URl and applying filters added in URL
  if (canUseDOM && shouldCheckURL) {
    const searchString = queryString.parse(
      window && window.location && window.location.search,
      { arrayFormat: 'comma' }
    );
    searchString && searchString.tag && setAttributeListing(searchString.tag);
    if (Object.keys(searchString).length !== 0) {
      let updatedfiltersData = cloneDeep(filtersData);
      updatedfiltersData.map(data => {
        const value = searchString[data.fieldName.value]
          ? searchString[data.fieldName.value]
          : '';
        if (data.type === checkboxType) {
          if (Array.isArray(value) && value.length > 0) {
            data.listItems.map(listItem => {
              if (value.includes(listItem.fields.key.value)) {
                listItem.fields.selected.value = true;
              }

              return listItem;
            });
          } else {
            data.listItems.map(listItem => {
              if (listItem.fields.key.value === value) {
                listItem.fields.selected.value = true;
              }
              return listItem;
            });
          }
        } else if (data.type === calendarType) {
          if (searchString.startDate && searchString.endDate) {
            let this_stateDate = moment(searchString.startDate, 'MM-DD-YYYY');
            let this_endDate = moment(searchString.endDate, 'MM-DD-YYYY');
            data.startDate.value = this_stateDate.toDate();
            data.endDate.value = this_endDate.toDate();
          }
        } else {
          data.selectedValue.value = value;
        }
        return data;
      });
      setTimeout(() => {
        props.updateQueryFilterData(updatedfiltersData);
      }, 0);
    }
    setShouldCheckURL(false);
  }
  /*
   *  This function gets called when user open filters drawer on mobile
   */
  const toggleDrawer = () => {
    setShouldOpenDrawer(!shouldOpenDrawer);
  };

  /*
   *  This function gets called when user clicks apply button on mobile after selecting filters
   */
  const onApplyClick = () => {
    props.mobileFiltersUpdate(dummyFiltersData);
    toggleDrawer();
  };

  /*
   *  This function handles onChange events of filters on desktop
   */
  const onFilterChange = event => {
    const target = {
      name: event.target.name,
      value: event.target.value,
      checked: event.target.checked,
    };
    addAnalyticsInfo(target);
    setIsFirstLoad(false);
    props.updateFiltersData(target);
    if (parentComponentName === 'FavoriteSubLayout') {
      fetchFavoriteListing();
    }

  };
  /*
   *  This function returns typography text based on label, variant and classname provided
   */
  const renderText = (label, variant, className) => {
    return (
      <Typography variant={variant} gutterBottom={false} className={className}>
        <Text field={label} />
      </Typography>
    );
  };

  /*
   *  This function set mobile state to intial state when the filters popup was earlier opened in case of mobile
   */
  const onCloseClickMobile = () => {
    if (filtersData && filtersData.length > 0) {
      let data = cloneDeep(filtersData);
      setDummyFiltersData(data);
      setDummyFiltersLength(props.selectedFiltersData.filterCount);
    }
  };

  /*
   *  This function clears filters present on mobile filters state
   */
  const onResetClickMobile = () => {
    if (dummyFiltersData && dummyFiltersData.length > 0) {
      let data = dummyFiltersData;
      data.map(value => {
        if (value.type === checkboxType) {
          value.listItems.map(list => {
            list.fields.selected.value = false;

            return list;
          });
        } else if (value.type === calendarType) {
          value.startDate.value = '';
          value.endDate.value = '';
        } else {
          value.selectedValue.value = '';
        }

        return value;
      });
      setDummyFiltersData(data);
      setDummyFiltersLength(0);
    }
  };

  /*
   *  This function renders link
   */
  const renderLink = (linkText, className, onClick) => {
    return (
      <CustomLink
        link={{
          value: { href: '', title: '', target: '', class: '' },
        }}
        className={className}
        onClick={e => {
          e.preventDefault();
          onClick();
        }}
      >
        {renderText(linkText, 'body2Bold')}
      </CustomLink>
    );
  };

  /*
   *  This function returns filters fields from the filtersData state
   *  along with bind all the helper functions required
   */
  const renderFiltersFields = (filtersData, onChangeFunc) => {
    return filtersData.map((data, index) => {
      const Field = mapper[data.type];
      if (Field) {
        return (
          <div
            className={clsx(
              classes.container,
              data.type === dropdownType && classes.dropdown,
              // This comments for Event page
              contentType === EVENT_TYPE && classes.eventColor
            )}
            key={index}
          >
            <Field
              data={data}
              onChange={onChangeFunc}
              seeLessText={seeLessText}
              seeMoreText={seeMoreText}
              shouldShowLimited
              shouldShowResultsCount={isGlobalSearchTemplate}
              isGroupedDropdown={data.fieldName.value === regionTaxonomyKey}
              isFilterRating={data.fieldName.value === tripadvisorratingTaxonomyKey}
            />
            {data.fieldName.value === priceTaxonomyKey ? (
              <div className={classes.priceRangeText}>
                {renderText(priceRangeHelpText, 'body2')}
              </div>
            ) : (
              ''
            )}
          </div>
        );
      }

      return null;
    });
  };

  /*
   *  This function gets called when user clickes clearALL on browser
   */
  const onClearAllClick = () => {
    props.clearFilterData();
    props.clearAllClicked(true);
    if (isGlobalSearchTemplate) {
      fetchSearchResults(searchTerm, language);
    }
    if (parentComponentName === 'FavoriteSubLayout') {
      fetchFavoriteListing();
    }
  };

  /*
   *  This function returns filters section HTML
   */
  const filterDOM = () => {
    let updatedTitle = `${title.value}${props.selectedFiltersData.filterCount
      ? `(${props.selectedFiltersData.filterCount})`
      : ''
      }`;
    let selectedFilter = `${dummyFiltersLength
      ? `( ${dummyFiltersLength} ) ${selectedFilterText.value}`
      : ''
      }`;
    return (
      <div className={classes.filterSection}>
        <div className={classes.container}>
          <Hidden mdDown implementation="css">
            {renderText(
              { value: updatedTitle },
              'body2Bold',
              classes.filterText
            )}
          </Hidden>
          <Hidden lgUp implementation="css">
            {renderText(title, 'body2Bold', classes.filterText)}
          </Hidden>
          {props.selectedFiltersData.filterCount ? (
            <Hidden mdDown implementation="css">
              {renderLink(
                clearAllText,
                classes.clearAllButton,
                onClearAllClick
              )}
            </Hidden>
          ) : (
            ''
          )}
          {props.selectedFiltersData.filterCount ? (
            <Hidden lgUp implementation="css">
              {renderLink(resetText, classes.resetButton, onResetClickMobile)}
            </Hidden>
          ) : (
            ''
          )}
          <Hidden lgUp implementation="css">
            <DctSvgIcon
              name="CloseIcon"
              onClick={() => {
                toggleDrawer();
                onCloseClickMobile();
              }}
            />
          </Hidden>
        </div>
        {isMobile
          ? renderFiltersFields(dummyFiltersData, onChangeMobile)
          : renderFiltersFields(filtersData, onFilterChange)}
        <Hidden lgUp implementation="css">
          <div className={classes.mobileFooter}>
            {renderText(
              { value: selectedFilter },
              'body2Bold',
              classes.heading
            )}
            <ButtonMUI
              buttonType={'form'}
              type={'button'}
              onClick={() => onApplyClick()}
              hasBorder={false}
              field={{ value: { text: applyText && applyText.value } }}
              iconOnly={false}
              // This comments for Event page
              className={contentType === EVENT_TYPE ? classes.eventBtnColor : ''}
            />
          </div>
        </Hidden>
      </div>
    );
  };
  if (props && !props.fields) {
    return null;
  }

  return (
    <Grid
      item
      className={classes.filterWrappeer}
      data-locator={FILTER_CONTAINER}
    >
      <Hidden lgUp implementation="css">
        {!isGlobalSearchTemplate && contentType !== ATTRIBUTE_TYPE ? <div className={classes.viewAllMobileBtn}>
          <ButtonMUI
            buttonType={'form'}
            type={'button'}
            onClick={() => fetchAllResults(contentType, language)}
            hasBorder={false}
            field={{ value: { text: renderText({ value: `${getDictionaryText('listingViewAllText')} ${filtersDataLength}` }, 'body2Bold', '') } }}
            iconOnly={false}
            classes={{ endIcon: classes.viewAllBtnEndIcon }}
          />
        </div> : ''}
        <div
          className={classes.togglefilterButton}
          data-locator={FILTER_LIST_MOBILE_SECTION}
        >
          <ButtonMUI
            buttonType={'form'}
            type={'button'}
            onClick={() => toggleDrawer()}
            hasBorder={false}
            isStartIcon
            field={{ value: { text: filtersText && filtersText.value } }}
            iconName={'FilterListIcon'}
            // This comments for Event page
            className={contentType === EVENT_TYPE ? classes.eventBtnColor : ''}
          />
        </div>
        <SwipeableDrawer
          open={shouldOpenDrawer}
          onOpen={() => { }}
          onClose={() => toggleDrawer()}
          className={classes.filterMobileContainer}
        >
          {filterDOM()}
        </SwipeableDrawer>
      </Hidden>
      <Hidden mdDown implementation="css">
        {!isGlobalSearchTemplate && contentType !== ATTRIBUTE_TYPE && parentComponentName !== 'FavoriteSubLayout' ? <div className={classes.desktopViewAllSection}>
          <div className={classes.listingText}>
            {renderText({ value: filtersDataLength }, 'h4', '')}
            {renderText({ value: getDictionaryText('listings') }, 'body1', '')}
          </div>
          <ButtonMUI
            buttonType={'form'}
            type={'button'}
            onClick={() => fetchAllResults(contentType, language)}
            hasBorder={false}
            field={{ value: { text: renderText({ value: getDictionaryText('viewThemAll') }, 'body2Bold', '') } }}
            iconOnly={false}
            // This comments for Event page
            className={contentType === EVENT_TYPE ? classes.eventBtnColor : ''}
          />
        </div> : ''}
        {filterDOM()}
      </Hidden>
    </Grid>
  );
};

export const mapDispatchToProps = dispatch => {
  return {
    getFiltersInfoData: params => dispatch(getFiltersInfoData(params)),
    getFiltersInfoSuccess: params => dispatch(getFiltersInfoSuccess(params)),
    updateFiltersData: params => dispatch(updateFiltersData(params)),
    updateSelectedFiltersData: params =>
      dispatch(updateSelectedFiltersData(params)),
    updateQueryFilterData: params => dispatch(updateQueryFilterData(params)),
    clearAllClicked: params => dispatch(clearAllClicked(params)),
    getFilterdInfoData: params => dispatch(getFilterdInfoData(params)),
    clearFilterData: params => dispatch(clearFilterData(params)),
    mobileFiltersUpdate: params => dispatch(mobileFiltersUpdate(params)),
    clearFilteredData: params => dispatch(clearFilteredData(params)),
    updateMultipleFiltersData: params =>
      dispatch(updateMultipleFiltersData(params)),
  };
};

export const mapStateToProps = createStructuredSelector({
  filtersData: filtersData,
  selectedFiltersData: selectedFiltersData,
  searchTermData: searchTermData,
  clearAllClickedData: clearAllClickedData,
});

export default withErrorBoundary(
  withSitecoreContext()(
    withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(Filters))
  )
);

export { Filters as FiltersTest };
